import { createDebugger } from '@iotize/common/debug';
const prefix = '@iotize/common:buffer-queue';
export const debug = createDebugger(prefix);
